import {
	FrontendClient,
	FrontendCompanyTestCategory,
	FrontendCompanyWithAdditionalInfomation,
} from "node-library/dist/portal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GreenButton } from "../../../../common-components/button";
import {
	CustomDropdown,
	CustomTextInput,
} from "../../../../common-components/inputs";
import { ModalWithButtons } from "../../../../common-components/modals/modal";

import { useSnackbar } from "../../../../common-components/toast/showToastMessage";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setNewOrderSelectedCategory: React.Dispatch<
		React.SetStateAction<FrontendCompanyTestCategory | undefined>
	>;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	clients: Array<FrontendClient>;
	selectClient: (client: FrontendClient) => void;
}

export default function SelectClientModal(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const { open, setOpen, clients, selectClient } = props;

	const [newOrderSelectedCategoryId, setNewOrderSelectedCategoryId] =
		useState<string>(
			props.company.companyTestCategories.length > 0
				? props.company.companyTestCategories[0].testCategoryId
				: ""
		);

	const [selectedClientId, setSelectedClientId] = useState<string>("");
	const [selectedClient, setSelectedClient] = useState<
		FrontendClient | undefined
	>(clients ? clients[0] : undefined);

	const infoFields: Array<any> = [
		{
			id: "client-email-input",
			label: `${translation("Email")}`,
			inputType: "email",
			value: selectedClient ? selectedClient.email : "",
			setValue: () => {},
			required: false,
			disabled: true,
		},
		{
			id: "client-phone-input",

			label: `${translation("PhoneNumber")}`,
			inputType: "tel",
			value: selectedClient ? selectedClient.phoneNumber : "",
			setValue: () => {},
			required: false,
			disabled: true,
		},
	];

	useEffect(() => {
		if (open) {
			setSelectedClientId(
				clients && clients.length > 0 ? clients[0].clientId : ""
			);
			setNewOrderSelectedCategoryId(
				props.company.companyTestCategories.length > 0
					? props.company.companyTestCategories[0].testCategoryId
					: ""
			);
		}
	}, [open, clients]);

	useEffect(() => {
		if (selectedClientId) {
			setSelectedClient(
				clients.find((client) => {
					return client.clientId === selectedClientId;
				})
			);
		} else {
			setSelectedClient(undefined);
		}
	}, [selectedClientId]);

	const selectNewOrderTestCategoryDropdown: React.ReactNode = (
		<CustomDropdown
			id={"select-test-category-dropdown"}
			label={translation("TestCategory")}
			options={props.company.companyTestCategories.map(
				(category: FrontendCompanyTestCategory) => {
					return {
						title: `${category.testCategoryName}`.trim(),
						value: category.testCategoryId,
					};
				}
			)}
			value={newOrderSelectedCategoryId}
			setValue={setNewOrderSelectedCategoryId}
			displayEmpty
		></CustomDropdown>
	);

	const selectClientDropdown: React.ReactNode = (
		<CustomDropdown
			id={"select-client-dropdown"}
			label={translation("Name")}
			options={clients.map((client: FrontendClient) => {
				return {
					title: `${client.firstName || ""} ${client.lastName || ""}`.trim(),
					value: client.clientId,
				};
			})}
			value={selectedClientId}
			setValue={setSelectedClientId}
			displayEmpty
		></CustomDropdown>
	);

	const registrationInputs: Array<React.ReactNode> = infoFields.map(
		(field, index) => {
			return (
				<CustomTextInput
					id={field.id}
					key={field.id}
					value={field.value}
					setValue={field.setValue}
					disabled={field.disabled}
					label={field.label}
					type={field.inputType}
					required={field.required}
					errorMsg={field.errorMsg}
					setErrorMsg={field.setErrorMsg}
				></CustomTextInput>
			);
		}
	);

	const registrationContent: React.ReactNode = (
		<div className="registration-input-content">
			{selectNewOrderTestCategoryDropdown}
			{selectClientDropdown}
			<div className="register-grid-row">
				{registrationInputs[0]}
				{registrationInputs[1]}
			</div>
		</div>
	);

	const selectClientModal: React.ReactNode = (
		<ModalWithButtons
			modalWidth={500}
			headerText={translation("SelectClient")}
			// headerDescription={translation("ConfirmApprovalDescription")}
			open={open}
			setOpen={setOpen}
			buttons={[
				<GreenButton
					key="submit-client-change-button"
					id="submit-client-change-button"
					children={translation("Select")}
					disabled={!selectedClient || !newOrderSelectedCategoryId}
					onClick={() => {
						if (!selectedClient || !newOrderSelectedCategoryId) {
							return;
						}
						props.selectClient(selectedClient);
						props.setNewOrderSelectedCategory(
							props.company.companyTestCategories.find((category) => {
								return category.testCategoryId === newOrderSelectedCategoryId;
							})
						);
					}}
				></GreenButton>,
			]}
		>
			{registrationContent}
		</ModalWithButtons>
	);
	return selectClientModal;
}
